import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getPasswordRecoveryState,
} from '../../../store/reducers';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { PasswordRecoveryManagementState } from '../../store/reducers/password-recovery-management.reducer';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { emailFormatRegEx } from '@proximus/ng-common';
import { PasswordRecoveryManagementValidator } from '../../validators/password-recovery-management.validator';

@Component({
  selector: 'mprd-email-active-container',
  templateUrl: 'email-active-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailActiveContainerComponent implements OnInit {
  emailSubmitForm: UntypedFormGroup;
  isEmailFormHasErrors: boolean;

  activeEmailId: string;
  showChangeEmailId = false;
  showLoadingSpinner: boolean;

  constructor(
    private builder: UntypedFormBuilder,
    private store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
    private passwordRecoveryManagementValidator: PasswordRecoveryManagementValidator,
  ) {}

  ngOnInit() {
    this.store
      .select(getPasswordRecoveryState)
      .subscribe(
        (passwordRecoveryManagementState: PasswordRecoveryManagementState) => {
          if (
            passwordRecoveryManagementState.passwordRecoveryManagement &&
            passwordRecoveryManagementState.passwordRecoveryManagement.email
          ) {
            this.activeEmailId =
              passwordRecoveryManagementState.passwordRecoveryManagement.email.mail;
          }
        },
      );
    this.emailSubmitForm = this.builder.group({
      emailId: [
        '',
        [
          Validators.required,
          Validators.pattern(emailFormatRegEx),
          this.passwordRecoveryManagementValidator.checkForbiddenRecoveryEmailValues(),
        ],
      ],
    });
    this.emailSubmitForm.valueChanges.subscribe((value) => {
      this.isEmailFormHasErrors =
        this.emailSubmitForm.get('emailId').dirty &&
        !this.emailSubmitForm.pending &&
        !this.emailSubmitForm.get('emailId').valid;
    });
  }

  isNewMailEmpty() {
    return this.emailSubmitForm.controls['emailId']?.value.length === 0;
  }

  onEmailSubmitCancel() {
    this.showChangeEmailId = !this.showChangeEmailId;
  }

  onValidEmailSubmit(emailId: string) {
    this.showChangeEmailId = false;
    this.setEmailRecovery(emailId);
  }

  setEmailRecovery(emailId = this.activeEmailId) {
    this.store.dispatch(
      new RecoveryMethodsActions.SetEmailRecoveryMethodAction(emailId),
    );
  }
}
